import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';

let firstText = <p>To book a car on Turo, you must create a Turo account, be 18 years old or older in the US, 21 years old or older in the UK, 23 years old or older in Canada, have a valid driver’s license, and get approved to drive on Turo. When you’re booking your first trip, you’ll go through a quick approval process by entering your driver’s license and some other information. In most cases, you’ll get approved immediately, and you’ll be set for all future road trips, day trips, and business trips!</p>
let secline_firstText = <p>If there’s an emergency or an issue with the car, call our emergency roadside assistance provider, available 24/7. We’ll make sure you’re safe, then help you get back on your way.</p>
const items = [
  {
    label: <a href="https://www.antgroup.com">{firstText}</a>,
    key: '0',
  },

];
const FreqQuest = () => {
  return (
    
      <h3 className="freq-quest-child1" >
        Frequently asked questions</h3>
  )
}

const FreqQuest2 = () => {
  return (
    <>
        <div className="freq-quest-child3">
          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                What do I need to book a car on Turo?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Do I need my own insurance?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Can other people drive a car that I booked?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                What is the cancellation policy on Turo?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
          
       
        {/* <h1>subhan</h1> */}
         </div>

        <div className="freq-quest-child4">
          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                What happens if I have an accident?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Can I get my car delivered to me?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                How do I get discounts when booking a car?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>

          <Dropdown
            menu={{
              items,
            }}
            trigger={['click']}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                What do I need to book a car on Turo?
                <DownOutlined />
              </Space>
            </a>
          </Dropdown>
{/* <h1>subhan</h1> */}
        </div>

     </>
 
  
    )
  }
  export  {FreqQuest,FreqQuest2};

    